import { getJsonClassName } from '@sumbricht/json-class-serializer'

export function getJsonTypeName(obj: object, fallback?: string): string {
	return getJsonClassName(obj) || fallback || ''
}
